import { createReducer, on } from '@ngrx/store';
import { CareLinksActions } from './care-links.actions';
import { AuthActions } from '../auth/auth.actions';
import { CareLinksState, initialCareLinksState } from './models/care-links-state.models';

export const careLinksReducer = createReducer(
  initialCareLinksState,

  // Load caregivers
  on(CareLinksActions.loadCaregivers, (state): CareLinksState => ({
    ...state, loading: true, error: null
  })),
  on(CareLinksActions.loadCaregiversSuccess, (state, { caregivers }): CareLinksState => ({
    ...state, caregivers, loading: false, error: null
  })),
  on(CareLinksActions.loadCaregiversFailure, (state, { error }): CareLinksState => ({
    ...state, loading: false, error
  })),

  // Invite caregiver
  on(CareLinksActions.inviteCaregiver, (state): CareLinksState => ({
    ...state, inviting: true, error: null
  })),
  on(CareLinksActions.inviteCaregiverSuccess, (state): CareLinksState => ({
    ...state, inviting: false, error: null
  })),
  on(CareLinksActions.inviteCaregiverFailure, (state, { error }): CareLinksState => ({
    ...state, inviting: false, error
  })),

  // Revoke link
  on(CareLinksActions.revokeLink, (state): CareLinksState => ({
    ...state, loading: true, error: null
  })),
  on(CareLinksActions.revokeLinkSuccess, (state): CareLinksState => ({
    ...state, loading: false, error: null
  })),
  on(CareLinksActions.revokeLinkFailure, (state, { error }): CareLinksState => ({
    ...state, loading: false, error
  })),

  // Resend invitation
  on(CareLinksActions.resendInvitation, (state): CareLinksState => ({
    ...state, loading: true, error: null
  })),
  on(CareLinksActions.resendInvitationSuccess, (state): CareLinksState => ({
    ...state, loading: false, error: null
  })),
  on(CareLinksActions.resendInvitationFailure, (state, { error }): CareLinksState => ({
    ...state, loading: false, error
  })),

  // Clear
  on(CareLinksActions.clearCareLinksState, (): CareLinksState => initialCareLinksState),
  on(CareLinksActions.clearError, (state): CareLinksState => ({
    ...state, error: null
  })),

  // Clear on logout
  on(AuthActions.logoutSuccess, (): CareLinksState => initialCareLinksState),
);
